import React from 'react'
import { withStyles } from '@material-ui/core'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { get } from 'lodash'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { currency } from '../../../../../helpers'

const useStyles = makeStyles(theme => ({
	table: {
		minWidth: 700,
	},
	bgBlack: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
		border: 'solid 1px lightgrey',
	},
	bgBlueGrey: {
		backgroundColor: '#424242',
		color: theme.palette.common.white,
		border: 'solid 1px lightgrey',
	},
	bgWhite: {
		border: '1px solid #ffffff',
	},
	footerLabelCell: {
		border: 'solid 1px lightgrey !important',
		paddingTop: '5px !important',
		paddingBottom: '5px !important'
	},
	footerLabelRow: {
		height: '0px'
	},
	bgLightBlue: {
		backgroundColor: '#dbe5f1',
		color: theme.palette.common.black,
		border: '1px solid white',
	},
	bgLightGreen: {
		backgroundColor: '#6fcdb3',
		color: theme.palette.common.black,
		border: '1px solid white',
	},
	noBorder: {
		border: '0px !important',
	},
	emptyRow: {
		height: '40px !important',
	},
	leftJustified: {
		textAlign: 'left !important',
	},
	reportTableContainer: {
		overflowX: 'scroll',
		paddingBottom: '15px'
	},
	salaryCell: {
		paddingRight: '7px !important',
		textAlign: 'right !important'
	},
}))

const StyledTableCell = withStyles(theme => ({
	head: {
		padding: theme.spacing(1),
		fontSize: 12,
		border: 'solid 1px lightgrey',
		textAlign: 'center',
		whiteSpace: 'nowrap',
	},
	body: {
		fontSize: 11,
		textAlign: 'center',
		whiteSpace: 'nowrap',
	},
	footer: {
		textAlign: 'center',
	},
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
	root: {
		height: 'auto',
	},
}))(TableRow)

export default function ProjectedHeadCountReport(props) {

	const classes = useStyles()

	return (
		<div className={classes.reportTableContainer}>
			<Table className={classes.reportTable} size="small">
				<TableHead>
					<TableRow>
						<StyledTableCell colSpan={3} className={clsx(classes.noBorder, classes.alignLeft)}>
							{`Currency: ${props.currencyCode}`}
						</StyledTableCell>
					</TableRow>
					<TableRow>
						<StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell colSpan={2}>{props.groupsNames[group]}</StyledTableCell>
									<StyledTableCell colSpan={4} className={classes.bgWhite}>
										Current
									</StyledTableCell>
									<StyledTableCell colSpan={4} className={classes.bgWhite}>
										Growth
									</StyledTableCell>
									<StyledTableCell colSpan={4} className={classes.bgWhite}>
										Future
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
								</React.Fragment>
							)
						}
					</TableRow>
					<TableRow>
						<StyledTableCell className={clsx(classes.bgBlack, classes.noBorder)}>
							Global Grade
						</StyledTableCell>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell
										className={classes.bgBlueGrey}
									>
										{'Cat/Level'}
									</StyledTableCell>
									<StyledTableCell
										className={classes.bgBlueGrey}
									>
										Job Title
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										n
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										Total($)
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										Average($)
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										%
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										n
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										Total($)
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										Average($)
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										%
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										n
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										Total($)
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										Average($)
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										%
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}>
									</StyledTableCell>
								</React.Fragment>
							)
						}
					</TableRow>
				</TableHead>
				<TableBody>
					{
						props.levelsData.map((levelData, i) => {
							return (
								<StyledTableRow key={i}>
									<StyledTableCell className={classes.bgBlack}>
										{i}
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
									{
										props.groups.map(group => {
											const groupLevelData = levelData[group]
											const level = get(groupLevelData, 'level', '')
											return (
												<React.Fragment key={`${i}${group}`}>
													<StyledTableCell className={level ? classes.bgBlack : classes.bgWhite}>
														{get(groupLevelData, 'level', '')}
													</StyledTableCell>
													<StyledTableCell align="left" className={clsx(classes.leftJustified, level ? classes.bgBlack : classes.bgWhite)}>
														{get(groupLevelData, 'title', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.n', '') ? get(groupLevelData, 'current.n', '') : null}
													</StyledTableCell>
													<StyledTableCell className={clsx(level ? classes.bgLightBlue : classes.bgWhite, classes.salaryCell)}>
														{get(groupLevelData, 'current.n', '') ? currency(get(groupLevelData, 'current.salary', ''), props.currencyCode) : ''}
													</StyledTableCell>
													<StyledTableCell className={clsx(level ? classes.bgLightBlue : classes.bgWhite, classes.salaryCell)}>
														{get(groupLevelData, 'current.n', '') ? currency(get(groupLevelData, 'current.average_salary', ''), props.currencyCode) : ''}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.n', '') ? get(groupLevelData, 'current.percent', '') : null}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'growth.n', '') ? get(groupLevelData, 'growth.n', '') : null}
													</StyledTableCell>
													<StyledTableCell className={clsx(level ? classes.bgLightBlue : classes.bgWhite, classes.salaryCell)}>
														{get(groupLevelData, 'growth.n', '') ? currency(get(groupLevelData, 'growth.salary', ''), props.currencyCode) : ''}
													</StyledTableCell>
													<StyledTableCell className={clsx(level ? classes.bgLightBlue : classes.bgWhite, classes.salaryCell)}>
														{get(groupLevelData, 'growth.n', '') ? currency(get(groupLevelData, 'growth.average_salary', ''), props.currencyCode) : ''}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'growth.n', '') ? get(groupLevelData, 'growth.percent', '') : null}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'future.n', '') ? get(groupLevelData, 'future.n', '') : null}
													</StyledTableCell>
													<StyledTableCell className={clsx(level ? classes.bgLightBlue : classes.bgWhite, classes.salaryCell)}>
														{get(groupLevelData, 'future.n', '') ? currency(get(groupLevelData, 'future.salary', ''), props.currencyCode) : ''}
													</StyledTableCell>
													<StyledTableCell className={clsx(level ? classes.bgLightBlue : classes.bgWhite, classes.salaryCell)}>
														{get(groupLevelData, 'future.n', '') ? currency(get(groupLevelData, 'future.average_salary', ''), props.currencyCode) : ''}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'future.n', '') ? get(groupLevelData, 'future.percent', '') : null}
													</StyledTableCell>
													<StyledTableCell className={classes.noBorder}>
													</StyledTableCell>
												</React.Fragment>
											)
										})
									}
								</StyledTableRow>
							)
						})
					}
					<StyledTableRow>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
					</StyledTableRow>
					<StyledTableRow>
						<StyledTableCell colSpan={1} className={classes.bgLightGreen}>Total {props.currentTotalN}</StyledTableCell>
						<StyledTableCell colSpan={1} className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell className={classes.noBorder} colSpan={2}></StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'current.total', '')}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
										{currency(get(props.groupSummary[group], 'current.salary', ''), props.currencyCode)}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
										{
											get(props.groupSummary[group], 'current.total', '') !== 0 ?
											currency(get(props.groupSummary[group], 'current.salary', '') / get(props.groupSummary[group], 'current.total', ''), props.currencyCode)
											:
											''
										}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'current.percent', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'growth.total', '')}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
										{currency(get(props.groupSummary[group], 'growth.salary', ''), props.currencyCode)}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
										{
											get(props.groupSummary[group], 'growth.total', '') !== 0 ?
												currency(get(props.groupSummary[group], 'growth.salary', '') / get(props.groupSummary[group], 'growth.total', ''), props.currencyCode)
												:
												''
										}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'growth.percent', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'future.total', '')}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
										{currency(get(props.groupSummary[group], 'future.salary', ''), props.currencyCode)}
									</StyledTableCell>
									<StyledTableCell className={clsx(classes.bgLightGreen, classes.salaryCell)}>
										{
											get(props.groupSummary[group], 'future.total', '') !== 0 ?
											currency(get(props.groupSummary[group], 'future.salary', '') / get(props.groupSummary[group], 'future.total', ''), props.currencyCode)
											:
											''
										}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'future.percent', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}>
									</StyledTableCell>
								</React.Fragment>
							)
						}
					</StyledTableRow>
					<TableRow className={classes.footerLabelRow}>
						<StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
									<StyledTableCell colSpan={4} className={classes.footerLabelCell}>
										Current
									</StyledTableCell>
									<StyledTableCell colSpan={4} className={classes.footerLabelCell}>
										Growth
									</StyledTableCell>
									<StyledTableCell colSpan={4} className={classes.footerLabelCell}>
										Future
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
								</React.Fragment>
							)
						}
					</TableRow>
				</TableBody>
			</Table>
		</div>
	)
}

